import React from "react";
import numbro from "numbro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faTimesCircle,
  faEye,
  faSyncAlt,
  faUsers,
  faUsersSlash
} from "@fortawesome/free-solid-svg-icons";
import HotTable from "@handsontable/react";
import { propTypes } from "./propTypes";
import { tableSettings } from "./tableSettings";
import languages from "numbro/dist/languages.min.js";

numbro.registerLanguage(languages["de-DE"]); // €
numbro.registerLanguage(languages["en-GB"]); // £
numbro.registerLanguage(languages["ja-JP"]); // ¥

import "./handsonTable.scss";
import NumberDisplay from "../numberDisplay/numberDisplay";
// import { stripHTMLTagsFromText } from "../../utils/formatters";
import { xlsxExport } from "../../utils/xlsxExport";

const getFilteredData = (filteredData, hiddenCols) =>
  filteredData.filter((_, i) => !hiddenCols.includes(i));

class HandsonTable extends React.Component {
  static propTypes = propTypes;
  static defaultProps = {
    currencySymbol: ""
  };

  constructor(props) {
    super(props);
    this.hotSettings = tableSettings(props);
    this.state = {
      columns: this.props.columns,
      hideScroll: false
    };

    this.hotTableComponent = React.createRef();
  }

  downloadFile = () => {
    let exportFile = this.hotTableComponent.current.hotInstance.getPlugin("exportFile");
    exportFile.downloadFile("csv", {
      bom: false,
      columnDelimiter: ",",
      columnHeaders: true,
      exportHiddenColumns: false,
      exportHiddenRows: false,
      fileExtension: "csv",
      filename: "ikizmet_raw_data",
      mimeType: "text/csv",
      rowDelimiter: "\r\n"
    });
  };

  resizeFirstCol = () => {
    let width = this.props.firstColWidth;
    if (width !== undefined) {
      let autoColumnSize = this.hotTableComponent.current.hotInstance.getPlugin("autoColumnSize");
      this.hotTableComponent.current.hotInstance.updateSettings({
        colWidths: function (index) {
          if (index === 0) {
            return width;
          } else {
            // Calculate for column at index `index` and row at index 0
            autoColumnSize.calculateColumnsWidth(index, 0, true);
            return autoColumnSize.getColumnWidth(index);
          }
        }
      });
    }
  };

  collapseAllNestedRows = () => {
    if (this.props.collapseAllNestedRows) {
      const tableWrapper = document.querySelector(".wtHolder:first-of-type");
      const needToHideScroll = tableWrapper.clientWidth === tableWrapper.scrollWidth;

      if (needToHideScroll) {
        this.setState({
          hideScroll: true
        });
      }

      let nestedRows = this.hotTableComponent.current.hotInstance.getPlugin("nestedRows");
      nestedRows.collapsingUI.collapseAll();
    }
  };

  reloadTableData = () => {
    this.props.startPolling();
  };

  render() {
    this.hotSettings = tableSettings(this.props, {
      afterInit: () => {
        setTimeout(() => {
          this.resizeFirstCol();
          this.collapseAllNestedRows();
        }, 0);
      },
      ...this.state
    });
    return (
      <>
        {(this.props.showCloseWindowButton ||
          this.props.showExportFileButton ||
          this.props.showViewAllDataButton) && (
          <span className="handsontable-buttons">
            {this.props.showCloseWindowButton && (
              <a onClick={() => window.close()} className="btn-raw-data" href="#">
                <FontAwesomeIcon
                  className="minus-icon"
                  icon={faTimesCircle}
                  style={{ color: "#8ac934" }}
                />{" "}
                Close Raw Data View
              </a>
            )}

            {this.props.showSharedMembersDataButton && (
              <a className="btn-raw-data" href={this.props.showSharedMembersUrl}>
                <FontAwesomeIcon
                  className="minus-icon"
                  icon={faUsers}
                  style={{ color: "#8ac934" }}
                />{" "}
                Shared
              </a>
            )}

            {this.props.hideSharedMembersDataButton && (
              <a className="btn-raw-data" href={this.props.hideSharedMembersUrl}>
                <FontAwesomeIcon
                  className="minus-icon"
                  icon={faUsersSlash}
                  style={{ color: "#8ac934" }}
                />{" "}
                Hide Shared
              </a>
            )}
            {this.props.showExportFileButton &&
              this.props.data &&
              this.props.data.length <= 999999 && (
                <a
                  className="btn-raw-data"
                  onClick={() => {
                    const hi = this.hotTableComponent.current.hotInstance;
                    let hiddenCols = [],
                      data = hi.getData(),
                      headers = hi.getColHeader(),
                      columns = this.props.columns;
                    try {
                      hiddenCols = hi.getPlugin("hiddenColumns").getHiddenColumns();
                    } catch (e) {
                      console.error("Exporting XLSX without hidden columns!", e);
                    }

                    // if there are hidden cols, remove them from data and headers
                    if (hiddenCols.length > 0) {
                      data = data.map((row) => [...getFilteredData(row, hiddenCols)]);
                      headers = getFilteredData(headers, hiddenCols);
                      columns = getFilteredData(this.props.columns, hiddenCols);
                    }
                    xlsxExport({
                      data,
                      headers,
                      columns: columns,
                      fileName: "ikizmet_raw_data"
                    });
                  }}
                >
                  <FontAwesomeIcon
                    className="minus-icon"
                    icon={faDownload}
                    style={{ color: "#8ac934" }}
                  />{" "}
                  Download as Excel
                </a>
              )}
            {this.props.showExportFileButton && this.props.showExportCSV && (
              <a className="btn-raw-data" onClick={this.downloadFile}>
                <FontAwesomeIcon
                  className="minus-icon"
                  icon={faDownload}
                  style={{ color: "#8ac934" }}
                />{" "}
                Download as CSV
              </a>
            )}
            {this.props.showViewAllDataButton && (
              <a className="btn-raw-data" href={this.props.showViewAllDataUrl}>
                <FontAwesomeIcon className="minus-icon" icon={faEye} style={{ color: "#8ac934" }} />{" "}
                Show All Data
              </a>
            )}
            {process.env.NODE_ENV !== "production" && this.props.startPolling !== undefined && (
              <a className="btn-raw-data" onClick={this.reloadTableData}>
                <FontAwesomeIcon
                  className="sync-alt"
                  icon={faSyncAlt}
                  style={{ color: "#8ac934" }}
                />{" "}
                Refresh Data
              </a>
            )}
            {this.props.showViewSummaryButton && (
              <a className="btn-raw-data" href={this.props.showViewSummaryUrl}>
                <FontAwesomeIcon className="minus-icon" icon={faEye} style={{ color: "#8ac934" }} />{" "}
                Show Summary Data
              </a>
            )}
            {this.props.showViewBackButton && (
              <a className="btn-raw-data" href={this.props.showViewBackUrl}>
                <FontAwesomeIcon className="minus-icon" icon={faEye} style={{ color: "#8ac934" }} />{" "}
                Back to Detail View
              </a>
            )}

            {this.props.labelInfo && <h2 className="handsontable-label">{this.props.labelInfo}</h2>}
          </span>
        )}

        {this.props.headerInfo && Array.isArray(this.props.headerInfo) && (
          <div className="handsontable-actions">
            {this.props.headerInfo.map((data, i) => {
              let title = data[0].toLowerCase().trim();

              return (
                <div key={i} className="handsontable-actions__wrapper">
                  <div className="title">{data[0]}</div>
                  <div className="text">
                    {title.includes("revenue") ? (
                      data[1]
                    ) : (
                      <NumberDisplay value={data[1]} size="24px" disableAnimation />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div className={`hot__container ${this.state.hideScroll ? "hide-scroll" : ""}`}>
          <HotTable ref={this.hotTableComponent} settings={this.hotSettings} />
        </div>
      </>
    );
  }
}

export default HandsonTable;
